import * as fs from 'fs';
import * as path from 'path';
import { IStream } from "./IStream";
import { Log } from "./Log";

export class StreamFile implements IStream
{
    private baseName: string;
    private basePath: string;
    seprateByDate: boolean = true;
    seprateByLevel: boolean = true;
    constructor(basePath: string = "./")
    {
        this.basePath = basePath;
        this.baseName = this.getPackageName();
    }
    private getPackageName()
    {
        let pkgPath = path.resolve(process.cwd(), "");
        if (!pkgPath.endsWith('package.json'))
        {
            pkgPath = path.join(pkgPath, 'package.json');
        }
        if (fs.existsSync(pkgPath))
        {
            let json = fs.readFileSync(pkgPath) + "";
            let pkg = JSON.parse(json);
            return pkg.name;
        }
        return "";
    }
    private getFilePath(log: Log): string
    {
        let names = [this.baseName];
        if (this.seprateByDate)
            names.push(log.date.getFullYear() + "-" + (log.date.getMonth() + 1) + "-" + log.date.getDate());
        if (this.seprateByLevel)
            names.push(log.level + "");
        names.push(".log");
        let name = names.join("-");
        return path.resolve(this.basePath, name);
    }
    write(log: Log, formated: { pre: string[], messages: string[], post: string[] }): void
    {
        let filePath = this.getFilePath(log);
        fs.appendFile(filePath, [...formated.pre, ...formated.messages, ...formated.post].join("\n"), () => { });
    }
}